// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading: React.FC<{ text?: string }> = ({ text }) => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <CircularProgress sx={{ display: 'flex', mb: 2 }} />
      <Typography variant="body1">{text}</Typography>
    </Box>
  );
};

export default Loading;
